export default __webpack_public_path__ + "static/media/Locker.194b5d0a.svg";